export const printInformationArray = [
  {
    title: "News",
    description: "",
    awards: "",
    pages: [
      {
        type: "single",
        imageLink: "/projects/print/news/israel-gaza.png",
        pdfLink: "/projects/print/news/israel-gaza.pdf",
        awards: "",
      },
      {
        type: "single",
        imageLink: "/projects/print/news/life-expectancy.png",
        pdfLink: "/projects/print/news/life-expectancy.pdf",
        awards: "",
      },
      {
        type: "single",
        imageLink: "/projects/print/news/yip.png",
        pdfLink: "/projects/print/news/yip.pdf",
        awards: "",
      },
      {
        type: "single",
        imageLink: "/projects/print/news/baltimore-bridge.png",
        pdfLink: "/projects/print/news/baltimore-bridge.pdf",
        awards: "",
      },
      {
        type: "double",
        imageLink: "/projects/print/news/ev-southafrica.png",
        pdfLink: "/projects/print/news/ev-southafrica.pdf",
        awards: "",
      },
      {
        type: "double",
        imageLink: "/projects/print/news/wwi-spread.png",
        pdfLink: "/projects/print/news/wwi-spread.pdf",
        awards:
          "Award of Excellence from the Society of News Design (SND) for Regional/Local Page Design",
      },
    ],
  },
  {
    title: "American Icon",
    description: "Pages designed for the American Icon series about the AR-15.",
    awards: `These pages were part of the series that won the 2024 Pulitzer Prize for National Reporting and Best in Show at the 2024 SND Creative Competition`,
    pages: [
      {
        type: "single",
        imageLink: "/projects/print/ar-15/ar-15-a1.png",
        pdfLink: "/projects/print/ar-15/ar-15-a1.pdf",
        awards: "",
      },
      {
        type: "double",
        imageLink: "/projects/print/ar-15/ar-15.png",
        pdfLink: "/projects/print/ar-15ar-15.pdf",
        awards: "",
      },
    ],
  },
  {
    title: "Texas Rangers",
    description:
      "Worked with the digital designer on this story to best translate the design to print.",
    awards: `Award of Excellence from SND for Single Section`,
    pages: [
      {
        type: "single",
        imageLink: "/projects/print/texasrangers/texas-rangers.png",
        pdfLink: "/projects/print/texasrangers/texas-rangers-section.pdf",
        awards: "",
      },
      {
        type: "single",
        imageLink: "/projects/print/texasrangers/texas-rangers-2.png",
        pdfLink: "/projects/print/texasrangers/texas-rangers-section.pdf",
        awards: "",
      },
      {
        type: "double",
        imageLink: "/projects/print/texasrangers/texas-rangers-3.png",
        pdfLink: "/projects/print/texasrangers/texas-rangers-section.pdf",
        awards: "",
      },
      {
        type: "double",
        imageLink: "/projects/print/texasrangers/texas-rangers-4.png",
        pdfLink: "/projects/print/texasrangers/texas-rangers-section.pdf",
        awards: "",
      },
      {
        type: "double",
        imageLink: "/projects/print/texasrangers/texas-rangers-5.png",
        pdfLink: "/projects/print/texasrangers/texas-rangers-section.pdf",
        awards: "",
      },
    ],
  },
  {
    title: "The 47th President",
    description:
      "Selected pages from a special section ahead of the inauguration of Donald Trump",
    awards: ``,
    pages: [
      {
        type: "single",
        imageLink: "/projects/print/inauguration/inauguration-1.png",
        pdfLink: "/projects/print/inauguration/inauguration-1.pdf",
        awards: "",
      },
      {
        type: "double",
        imageLink: "/projects/print/inauguration/inauguration-3.png",
        pdfLink: "/projects/print/inauguration/inauguration-3.pdf",
        awards: "",
      },
      {
        type: "single",
        imageLink: "/projects/print/inauguration/inauguration-2.png",
        pdfLink: "/projects/print/inauguration/inauguration-2.pdf",
        awards: "",
      },
    ],
  },
  {
    title: "Features",
    description: "",
    awards: ``,
    pages: [
      {
        type: "double",
        imageLink: "/projects/print/features/photo-contest.png",
        pdfLink: "/projects/print/features/photo-contest.pdf",
        awards: "Silver Medal from SND for Single Section",
      },
      {
        type: "single",
        imageLink: "/projects/print/features/pizza-party.png",
        pdfLink: "/projects/print/features/pizza-party.pdf",
        awards: "",
      },
      {
        type: "single",
        imageLink: "/projects/print/features/where-to-go.png",
        pdfLink: "/projects/print/features/where-to-go.pdf",
        awards: "",
      },

      {
        type: "single",
        imageLink: "/projects/print/features/2020-look-back.png",
        pdfLink: "/projects/print/features/2020-look-back.pdf",
        awards: "",
      },
      {
        type: "single",
        imageLink: "/projects/print/features/2021-look-forward.png",
        pdfLink: "/projects/print/features/2021-look-forward.pdf",
        awards: "",
      },
      {
        type: "double",
        imageLink: "/projects/print/features/noodles.png",
        pdfLink: "/projects/print/features/noodles.pdf",
        awards: "",
      },
      {
        type: "single",
        imageLink: "/projects/print/features/year-of-pandemic-1.png",
        pdfLink: "/projects/print/features/year-of-pandemic-1.png",
        awards: "",
      },
      {
        type: "single",
        imageLink: "/projects/print/features/year-of-pandemic-2.png",
        pdfLink: "/projects/print/features/year-of-pandemic-2.png",
        awards: "",
      },
      {
        type: "single",
        imageLink: "/projects/print/features/year-of-pandemic.jpg",
        pdfLink: "/projects/print/features/year-of-pandemic.jpg",
        awards: "",
        description:
          "These two pages were printed on the front and back of one page. If you held it up to the light, you would see the outdoor scene through the window.",
      },
    ],
  },
];
